import React from 'react';
import { useHistory } from 'react-router-dom';
import { dateToMMMMYYYY } from '../../util/dateUtil.js';
import { makeStyles } from '@material-ui/core/styles';
import Card from '../Card/Card.js';
import CardBody from '../Card/CardBody.js';
import CardHeader from '../Card/CardHeader.js';
import { inject, observer } from 'mobx-react';
import { Button, Grid } from '@material-ui/core';
import { btNavyBlueColor, btOrangeColor } from '../../assets/jss/nextjs-material-kit-pro.js';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles((theme) => ({
  edit: {
    textAlign: 'center',
  },
  popover: {
    padding: theme.spacing(2),
  },
  dialogActions: {
    justifyContent: 'space-evenly',
  },
  card: {
    margin: 15,
    maxWidth: '320px',
    height: '195px',
  },
  cardBody: {
    padding: 10,
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 'dotted 1px gray',
    padding: '15px 10px 5px 10px',
    marginLeft: 0,
    marginRight: 0,
    marginTop: -10,
    fontWeight: 600,
  },
  tools: {
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  space5: {
    padding: 5,
  },
  noNotes: {
    paddingTop: 10,
  },
  dataLabel: {
    paddingTop: 10,
  },
  attachIcon: {
    paddingTop: 5,
  },
  dataBold: {
    fontWeight: 700,
  },
  idLink: {
    color: btNavyBlueColor,
    fontSize: '0.85rem',
    padding: 0,
    align: 'right',
  },
  cardLink: {
    color: btNavyBlueColor,
    fontSize: '0.85rem',
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
    },
    textTransform: 'none',
    textDecoration: 'underline',
  },
}));

const FamilyHomeListCard = inject(
  'SeniorStore',
  'AuthStore'
)(
  observer((props) => {
    const store = props.SeniorStore;

    const classes = useStyles();

    const history = useHistory();

    const EPOCH_DATE = /Date(0)/;

    const handleClickId = (event, id) => {
      event.preventDefault();
      event.stopPropagation();
      store.setBasicInfoId(id);
      store.setAlumni(false);
      history.push('/seniorplanner');
    };

    return (
      <React.Fragment>
        <Card className={classes.card} key={props.senior.id}>
          <CardHeader className={classes.cardHeader}>
            <Button
              className={classes.idLink}
              color="primary"
              size="small"
              aria-describedby="view personal information"
              onClick={(ev) => handleClickId(ev, props.senior.id)}
            >
              {props.senior.first_name} {props.senior.last_name}{' '}
            </Button>
            {!props.senior.userId && <WarningIcon style={{ marginRight: '5px', marginTop: '-2px', color: btOrangeColor }} />}
          </CardHeader>
          <CardBody className={classes.cardBody}>
            <section className={classes.dataBold}>
              <label>Graduation Date</label> {props.senior.graduation_date > EPOCH_DATE && dateToMMMMYYYY(props.senior.graduation_date)}
            </section>
            <Grid container>
              <Grid item xs={12} style={{ padding: '0 10px' }}>
                {(props.renderWorkbookModuleGrid || props.renderWorkbookModuleCells)?.(props.senior)}
              </Grid>
            </Grid>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  })
);

export default FamilyHomeListCard;
